import React from "react";
import RulesTitle from "./RulesTitle";
import RulesGrid from "./RulesGrid";

const RulesSection = ({ rules }) => {
  return (
    <div className="flex md:flex-row flex-col md:gap-0 gap-2.5 rounded-xl bg-headerbgColor lg:py-[30px] py-4 lg:px-6 px-3">
      <div className="w-full md:w-1/5">
        <RulesTitle />
      </div>
      <div className="w-full md:w-4/5">
        <RulesGrid rules={rules} />
      </div>
    </div>
  );
};

export default RulesSection;
